import Vue from 'vue'
import '@/@core/services/compositionApi'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import vuetify from './plugins/vuetify'
import { createPinia, PiniaVuePlugin } from 'pinia'
import { Chart, registerables } from "chart.js";
import zoomPlugin from "chartjs-plugin-zoom";
import '@/@core/styles/index.scss'

Vue.config.productionTip = false

Vue.use(PiniaVuePlugin)
export const pinia = createPinia()

Chart.register(...registerables, zoomPlugin);

new Vue({
  pinia,
  router,
  vuetify,
  render: h => h(App)
}).$mount('#app')
